import { LazyWithPreload } from "@/utils/lazy-import-with-preload";
import { ReactNode } from "react";
import { StepRouteItem } from "./routes.type";

interface AddRouteProps {
  path: string;
  children: ReactNode;
  lazyRoute: LazyWithPreload<unknown>;
  showStep?: boolean;
  showPrevious?: boolean;
  previousPath?: string;
}

export class StepRouter {
  private totalStep = 1;
  private routes: StepRouteItem[] = [];

  public getRoutes(): StepRouteItem[] {
    return this.routes;
  }

  public addRoute({
    path,
    children,
    lazyRoute,
    showStep = true,
    showPrevious = true,
    previousPath,
  }: AddRouteProps): void {
    const baseRoute: StepRouteItem = {
      path,
      children,
      isProtected: true,
      lazyRoute,
    };
    if (showStep) {
      baseRoute.step = this.totalStep++;
    }
    if (this.routes.length > 0) {
      this.routes[this.routes.length - 1].nextPath = path;
      if (showPrevious) {
        baseRoute.previousPath = previousPath ?? this.routes[this.routes.length - 1].path;
      }
    }

    this.routes.push(baseRoute);
  }
}
